<template>
  <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_315_1031)">
      <rect width="18" height="24" fill="white"/>
      <path d="M4 21C2.89543 21 2 20.1046 2 19V3H11L16 8V19C16 20.1046 15.1046 21 14 21H4Z" fill="#CEF39F" stroke="#51B920" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 3V9H16" stroke="#51B920" stroke-width="2" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_315_1031">
        <rect width="18" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>